export const filterNotesFn = (notes: object[], context: string) => {
  let filteredNotes
  if (context === 'seo') {
    filteredNotes = notes?.filter(note => ['seo']?.includes(note?.context))
  }
  return filteredNotes
}
